export enum COUNTRY_ISO_CODES {
  AUSTRALIA = 'AU',
  CANADA = 'CA',
  CROATIA = 'HR',
  CZECH_REPUBLIC = 'CZ',
  DENMARK = 'DK',
  FRANCE = 'FR',
  GERMANY = 'DE',
  HONG_KONG = 'HK',
  HUNGARY = 'HU',
  INDIA = 'IN',
  INDONESIA = 'ID',
  JAPAN = 'JP',
  MAINLAND_CHINA = 'CN',
  MALAYSIA = 'MY',
  NETHERLANDS = 'NL',
  NEW_ZEALAND = 'NZ',
  NORWAY = 'NO',
  PHILIPPINES = 'PH',
  POLAND = 'PL',
  ROMANIA = 'RO',
  SINGAPORE = 'SG',
  SOUTH_KOREA = 'KR',
  SWEDEN = 'SE',
  TAIWAN = 'TW',
  THAILAND = 'TH',
  UNITED_KINGDOM = 'UK',
  UNITED_STATES = 'US',
  VIETNAM = 'VN',
}
